<template>
	<div class="basic_wrap">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.go(-1)"></div>
			<div class="big_tit" @click="showCitem++">{{ $t('语言') }}</div>
		</div>
		<div class="wrap_box">
			<div class="item" @click="changeLang('pt_br', $event)">
				<div class="left flex_center">
					<div><img src="../images/language/pt_br.png"></div>
					<div class="info"> Brazilian Portuguese</div>
				</div>
				<div v-if="lang == 'th_th'">✓</div>
			</div>
		</div>
		<div class="wrap_box">
			<div class="item" @click="changeLang('en_us', $event)">
				<div class="left flex_center">
					<div><img src="../images/language/en_us.png"></div>
					<div class="info"> English</div>
				</div>
				<div v-if="lang == 'en_us'">✓</div>
			</div>
		</div>

		<div class="wrap_box" v-show="showCitem >= 5">
			<div class="item" @click="changeLang('zh_cn', $event)">
				<div class="left flex_center">
					<div><img src="../images/language/zh_cn.png"></div>
					<div class="info"> 简体中文</div>
				</div>
				<div v-if="lang == 'zh_cn'">✓</div>
			</div>
		</div>

	</div>
</template>

<script>
import Fetch from '../../utils/fetch'
import bsHeader from '../../components/bsHeader.vue'
import {
	Toast
} from 'vant'
export default {
	name: "language",
	components: {
		bsHeader
	},
	data() {
		return {
			showChinese: false,
			lang: this.$i18n.locale || "zh_cn",
			showCitem: 0,
		};
	},
	created() {
		//ifgot param a show ch
		if (this.$route.query.a) this.showChinese = true;
	},
	mounted() {

	},
	methods: {
		changeLang(lang, event) {
			Toast.loading({
				// mask: true,
				duration: 200
			})
			this.lang = lang;
			this.$i18n.locale = lang;
			localStorage.setItem("lang", lang);
			this.$router.go(-1);
		},
	}
};
</script>

<style lang="less" scoped>
.back_left {
	background: url(../../views/images/item/back.png) no-repeat center center;
	background-size: 50% 50%;
}

.big_tit {
	position: absolute;
	height: 25px;
	font-size: 18px;
	font-weight: 500;
	color: rgba(255, 255, 255, 1);
	line-height: 25px;
	top: 12px;
	left: 50%;
	transform: translateX(-50%);
}

.info {
	margin-left: 10px;
	font-size: 0.45rem;
}

.wrap_box {
	width: 90%;
	margin: 15px auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	background: rgb(43, 57, 103);

	.item {
		height: 50px;
		width: 95%;
		padding: 16px 0;
		border-bottom: 1px solid #204678;
		font-size: 14px;
		color: white;
		font-weight: bold;
		line-height: 20px;
		display: flex;
		justify-content: space-between;

		.right {
			width: 30px;
			height: 30px;
			background: url(../images/user/arrow.png) no-repeat center center;
			background-size: 100% 100%;
			margin-right: 10px;
		}

		.right_info {
			color: rgba(0, 0, 0, .6);

		}

		.tips {
			color: rgba(0, 0, 0, .6);
			margin-left: auto;
			margin-right: 4px;
			font-weight: normal;
		}

		.left {
			img {
				width: 33px;
				margin-top: 5px;
			}
		}
	}
}</style>
